import React, {
  cloneElement,
  isValidElement,
  type ReactElement,
  type CSSProperties,
} from 'react';
import { Icon, type IconProps } from 'semantic-ui-react';
import styled from 'styled-components';

interface IStyledContainerProps {
  iconSize: number;
}

const StyledContainer = styled.div<IStyledContainerProps>`
  position: relative;

  .icon-behind,
  .icon-front {
    position: absolute;
    min-width: ${({ iconSize }) => iconSize - 2}px !important;
    max-width: ${({ iconSize }) => iconSize - 2}px !important;
  }

  &&& {
    svg {
      width: ${({ iconSize }) => iconSize - 2}px !important;
      height: ${({ iconSize }) => iconSize - 2}px !important;
    }
  }

  .icon-behind {
    left: 0px;
    top: 0px;
  }

  .icon-front {
    right: 0px;
    bottom: 0px;
  }
`;

interface IDualIconProps {
  iconBehind?: ReactElement<IconProps>;
  iconFront?: ReactElement<IconProps>;
  size?: number | IconProps['size'];
  style?: CSSProperties;
}

export function DualIcon({
  iconBehind,
  iconFront,
  size = 12,
  style,
}: IDualIconProps): JSX.Element | null {
  const isNumberSize = typeof size === 'number';
  const numericSize = isNumberSize ? size : 12;
  const iconSizeProp = isNumberSize ? undefined : (size as IconProps['size']);

  if (isValidElement(iconBehind) && isValidElement(iconFront)) {
    return (
      <StyledContainer
        iconSize={numericSize}
        style={{
          width: numericSize + numericSize / 2,
          height: numericSize + numericSize / 5,
          ...style,
        }}
      >
        {cloneElement(iconBehind as ReactElement<IconProps>, {
          ...iconBehind.props,
          size: iconSizeProp,
          className: `${iconBehind.props.className ?? ''} icon-behind`,
        })}
        {cloneElement(iconFront as ReactElement<IconProps>, {
          ...iconFront.props,
          size: iconSizeProp,
          className: `${iconFront.props.className ?? ''} icon-front`,
        })}
      </StyledContainer>
    );
  }

  if (isValidElement(iconBehind)) return iconBehind;
  if (isValidElement(iconFront)) return iconFront;

  return null;
}
